// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__CH43p {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.styles_contentWrapper__reEUG {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_headingWrapper__Jt9kL {
  display: flex;
  justify-content: space-between;
}

.styles_headingText__PpTX7,
.styles_value__A1pAU {
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
}

.styles_headingText__PpTX7 {
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
}

.styles_valueSlider__W4UUM {
  font-weight: 700;
  color: #ffffff;
}

.styles_sliderButtonWrapper__ELncz {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.styles_sliderButton__PWVTl {
  padding: 4px;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
}

.styles_valueWrapper__5EZMQ {
  display: flex;
  justify-content: space-between;
}

.styles_value__A1pAU {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  text-align: right;
  color: #ffffff;
}

.styles_receiveButton__\\+bFII {
  align-self: flex-end;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.8);
}

.styles_buttonWrapper__IRuzT {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.styles_button__0kqIg {
  width: 100%;
  height: 57px;
}

.styles_inputBlock__wzd-P {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_inputHeading__i4UJM {
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
}

.styles_wrapperModal__bHpfQ {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (max-width: 768px) {
  .styles_wrapperModal__bHpfQ {
    max-width: 100%;
  }
}

.styles_valueModal__spGKx {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  color: #ffffff;
}

.styles_buttonModal__ovNzL {
  width: 100%;
  height: 57px;
}
@media (max-width: 768px) {
  .styles_buttonModal__ovNzL {
    max-width: 400px;
    align-self: center;
  }
}

.styles_contentWrapperModal__f1g4Z {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.styles_modalLink__RW27A {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.8);
}
@media (max-width: 1200px) {
  .styles_modalLink__RW27A {
    font-size: 14px;
  }
}

.styles_error__Ez9oV {
  margin-top: 8px;
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-align: right;
  text-transform: capitalize;
  color: #d33030;
}`, "",{"version":3,"sources":["webpack://./src/pages/LiquidityRemove/pageContent/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;AAFF;;AAKA;;EAEE,eAAA;EACA,iBAAA;EACA,wBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,+BCvBS;ADqBX;;AAKA;EACE,gBAAA;EACA,cClCM;ADgCR;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAFF;;AAKA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BCzCS;ED0CT,qCCjDQ;EDkDR,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;EACA,cCjEM;AD+DR;;AAKA;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BClES;ADgEX;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BC9FS;AD4FX;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;AE1EE;EFwEF;IAOI,eAAA;EADF;AACF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cCvHM;ADsHR;;AAIA;EACE,WAAA;EACA,YAAA;AADF;AE5FE;EF2FF;IAKI,gBAAA;IACA,kBAAA;EAAF;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BCvIS;ADuIX;AE5HE;EFuHF;IAQI,eAAA;EACF;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;EACA,0BAAA;EACA,cC9HI;AD+HN","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.contentWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.headingWrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.headingText,\n.value {\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n}\n\n.headingText {\n  font-weight: 300;\n  color: $white-50;\n}\n\n.valueSlider {\n  font-weight: 700;\n  color: $white;\n}\n\n.sliderButtonWrapper {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.sliderButton {\n  padding: 4px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  color: $white-80;\n  background: $white-3;\n  border-radius: 12px;\n}\n\n.valueWrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.value {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  text-align: right;\n  color: $white;\n}\n\n.receiveButton {\n  align-self: flex-end;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  color: $white-80;\n}\n\n.buttonWrapper {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.button {\n  width: 100%;\n  height: 57px;\n}\n\n.inputBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.inputHeading {\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-50;\n}\n\n.wrapperModal {\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  @include md {\n    max-width: 100%;\n  }\n}\n\n.valueModal {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  color: $white;\n}\n\n.buttonModal {\n  width: 100%;\n  height: 57px;\n\n  @include md {\n    max-width: 400px;\n    align-self: center;\n  }\n}\n\n.contentWrapperModal {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.modalLink {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  color: $white-80;\n\n  @include xl {\n    font-size: 14px;\n  }\n}\n\n.error {\n  margin-top: 8px;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-align: right;\n  text-transform: capitalize;\n  color: $red;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__CH43p`,
	"contentWrapper": `styles_contentWrapper__reEUG`,
	"headingWrapper": `styles_headingWrapper__Jt9kL`,
	"headingText": `styles_headingText__PpTX7`,
	"value": `styles_value__A1pAU`,
	"valueSlider": `styles_valueSlider__W4UUM`,
	"sliderButtonWrapper": `styles_sliderButtonWrapper__ELncz`,
	"sliderButton": `styles_sliderButton__PWVTl`,
	"valueWrapper": `styles_valueWrapper__5EZMQ`,
	"receiveButton": `styles_receiveButton__+bFII`,
	"buttonWrapper": `styles_buttonWrapper__IRuzT`,
	"button": `styles_button__0kqIg`,
	"inputBlock": `styles_inputBlock__wzd-P`,
	"inputHeading": `styles_inputHeading__i4UJM`,
	"wrapperModal": `styles_wrapperModal__bHpfQ`,
	"valueModal": `styles_valueModal__spGKx`,
	"buttonModal": `styles_buttonModal__ovNzL`,
	"contentWrapperModal": `styles_contentWrapperModal__f1g4Z`,
	"modalLink": `styles_modalLink__RW27A`,
	"error": `styles_error__Ez9oV`
};
export default ___CSS_LOADER_EXPORT___;
